import { FunctionComponent, ReactNode, RefObject } from "react";

import { ListPerson } from "../../../List/schema/list";
import { ThreadNavToast } from "../../../List/components/CampaignOverview/components/ThreadNavToast";
import { SelectedLeadsOverlay } from "../../components/SelectedLeadsOverlay";
import { InboxActionBar } from "./InboxActionBar";

interface InboxThreadPaneProps {
	threadWrapperRef: RefObject<HTMLDivElement>;
	currentListPerson?: ListPerson;
	selected: number[];
	isLoading: boolean;
	renderChatlog: (selected: number[], isLoading: boolean) => ReactNode;
	renderSendButtons: () => ReactNode;
}

/**
 * The Inbox thread column (PREC-3850): the chat log fills the column, the
 * scroll-gated thread-nav pill floats above it, and the action bar (Add /
 * clear drafts / send) docks in-flow at the column's bottom edge.
 */
export const InboxThreadPane: FunctionComponent<InboxThreadPaneProps> = ({
	threadWrapperRef,
	currentListPerson,
	selected,
	isLoading,
	renderChatlog,
	renderSendButtons,
}) => (
	<div
		ref={threadWrapperRef}
		className="h-full min-h-[100%] w-full min-w-0 overflow-hidden z-5 relative flex flex-col"
	>
		{selected.length > 0 && <SelectedLeadsOverlay />}
		<div className="flex-1 min-h-0">{renderChatlog(selected, isLoading)}</div>
		{currentListPerson && selected.length === 0 && (
			<ThreadNavToast key={currentListPerson.id} wrapperRef={threadWrapperRef} />
		)}
		<InboxActionBar listPerson={currentListPerson} renderSendButtons={renderSendButtons} />
	</div>
);
